// import server from './server';

const createStore = Vuex =>
  new Vuex.Store({
    strict: process.env.NODE_ENV === 'development',
    modules: {
      // server,
    },
  });
export default createStore;
